import { render, staticRenderFns } from "./personTagAboutStore.vue?vue&type=template&id=d04ca88c"
import script from "./personTagAboutStore.vue?vue&type=script&lang=js"
export * from "./personTagAboutStore.vue?vue&type=script&lang=js"
import style0 from "./personTagAboutStore.vue?vue&type=style&index=0&id=d04ca88c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports